import PropTypes from 'prop-types';

const propTypes = {
  logo: PropTypes.string,
  logoAlt: PropTypes.string,
  poweredByText: PropTypes.string,
  className: PropTypes.string,
};

function Branding({
  logo,
  logoAlt = 'Company logo',
  poweredByText = 'Powered by Micruity',
  className = '',
}) {
  return (
    <div className={`footer__title ${className}`.trim()}>
      {logo && (
        <img
          src={logo}
          alt={logoAlt}
          title={logoAlt}
        />
      )}
      {poweredByText && <div>{poweredByText}</div>}
    </div>
  );
}

Branding.propTypes = propTypes;

export default Branding;

// Copyright © 2025 Micruity Inc.
